export const X_URL = "https://x.com/SynaptixRH";
export const BUY_URL = "https://ponsfamily.com/launchpad/0xaba119e5d2f4f6cfe0ae0400042b61d213fd499b";
export const CHART_URL = "https://www.dextools.io/app/robinhood/pair-explorer/0x7198f861ee0b585c4db028f372d1aa8b2a6601b0";
export const CONTRACT_ADDRESS = "0xaba119e5d2f4f6cfe0ae0400042b61d213fd499b";

export const ASSETS = {
  logo: "/assets/synaptix-logo.png",
  art: "/assets/synaptix-art.png",
  ban: "/assets/synaptix-ban.webp",
};
